import { Link } from "react-router-dom";

export function CategoryChips({ categories = [] }) {
  return (
    <div className="flex flex-wrap gap-1.5">
      {categories.map((c) => (
        <span key={c} className="rounded-full border border-border bg-elevated px-2.5 py-0.5 text-[10px] font-medium uppercase tracking-widest text-muted-foreground">
          {c}
        </span>
      ))}
    </div>
  );
}

export function OppScore({ score = 0, confidence }) {
  const color = score >= 80 ? "text-accent" : score >= 60 ? "text-amber-400" : "text-muted-foreground";
  return (
    <div className="text-right">
      <div className={`font-display text-3xl font-extrabold tabular-nums ${color}`}>{score}</div>
      <div className="text-[10px] uppercase tracking-widest text-muted-foreground">score</div>
      {confidence != null && <div className="mt-0.5 text-xs text-muted-foreground">{confidence}% conf.</div>}
    </div>
  );
}

export function ScoreBreakdown({ scores = {} }) {
  return (
    <div className="grid gap-3 sm:grid-cols-2">
      {Object.entries(scores).map(([key, value]) => (
        <div key={key}>
          <div className="mb-1.5 flex justify-between text-xs">
            <span className="capitalize text-muted-foreground">{key.replaceAll("_", " ")}</span>
            <span className="font-semibold text-foreground">{value}</span>
          </div>
          <div className="h-1.5 overflow-hidden rounded-full bg-elevated">
            <div className="h-full rounded-full bg-accent transition-[width] duration-500" style={{ width: `${Math.max(0, Math.min(100, value))}%` }} />
          </div>
        </div>
      ))}
    </div>
  );
}

export function MiniMetric({ label, value }) {
  return (
    <div className="rounded-xl border border-border bg-elevated p-3 text-center">
      <div className="font-display text-lg font-bold text-foreground">{value ?? "—"}</div>
      <div className="mt-0.5 text-[10px] uppercase tracking-widest text-muted-foreground">{label}</div>
    </div>
  );
}

export function OpportunityLink({ opportunity, children }) {
  return <Link to={`/opportunities/${opportunity.id}`} className="block">{children}</Link>;
}
